// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3dOnv","header":"MessagesList_header__2yvsA","chat":"MessagesList_chat__2ZNku"};